import React from "react";
import TextCard from "../../text-card";
import ImageCard from "../../image-card";

const GridLayout = (props) => {
  const cards = Object.keys(props)
    .filter((key) => key.includes("Image-Card"))
    .map((key) => props[key]);

  const gridSmallIndex = [1, 2];

  return (
    <div
      className="module-container"
      style={{ backgroundColor: props?.backgroundColor || "white" }}
    >
      <div className="container">
        <div className="row grid-layout" data-cy="Grid Layout">
          <div
            className="col-xs-12 col-sm-12 col-md-3 text-card"
            data-cy="Text Card"
          >
            {props?.["Text-Card-1"] && <TextCard {...props["Text-Card-1"]} />}
          </div>

          <div
            className={`col-xs-12 col-sm-12 col-md-9 image-cards image-cards--${props?.direction}`}
            data-cy="Image Cards"
          >
            {cards.map(
              (cardData, i) =>
                cardData && (
                  <ImageCard
                    {...cardData}
                    isSmall={gridSmallIndex.includes(i)}
                    key={`card-${i}`}
                  />
                )
            )}
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default GridLayout;
